module.exports = __webpack_public_path__ + "static/img/cgy2.3ef8aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cgy2.png
// module id = g01n
// module chunks = 73